import(/* webpackMode: "eager" */ "/app/app/indicators/ods/documents/page.jsx");
